import styled from 'styled-components';

export const BannerSliderWithImageStyled = styled.div`
  background: ${(props) => (props.bgColor ? `${props.bgColor} !important` : props.theme.sectionBox.bodyBg)};
  position: relative;
  padding: 0;
  margin: 8px 0 32px 0;
  .slick-list {
    width: 100%;
    margin: 0;

    img {
      border-radius: 8px;
    }
  }

  .slick-slide img {
    width: 100%;
  }
  .slick-slider {
    .slick-arrow {
      &.slick-prev {
        left: -10px;
      }
      &.slick-next {
        right: -10px;
      }
      &.slick-disabled {
        display: none !important;
      }
    }
  }
  .imageTimerContainer {
    position: absolute;
  }

  .imageTimerStyle {
    position: absolute;
    bottom: 10px;
    left: 40px;
    max-width: 60vw;
  }

  .box {
    border-radius: 5px;
    cursor: pointer;
    color: transparent;

    & > div {
      width: 100%;
      height: 100%;
      position: relative !important;

      > img {
        width: 100% !important;
        height: ${(props) => !props?.isHeroPromoBanner && "100%"} !important;
        min-height: ${(props) => props?.isHeroPromoBanner ? "170px" : "340px"} !important;
        position: relative !important;
      }
    }
    .content {
      display: inline-flex;
      flex-direction: column;
      margin: 80px 0 0 100px;

      .line {
        color: ${(props) => props.theme.color.white};
        font-size: 24px;
        font-weight: 700;
        margin: 0;
        line-height: 1;
      }

      button {
        font-weight: 700;
        color: ${(props) => props.theme.text.medium};
        background: ${(props) => props.theme.color.white};
        border-color: ${(props) => props.theme.color.white};
        box-shadow: 0 4px 12px 0 ${(props) => props.theme.blue.dark}12;
        margin: 20px 0 0 0;
        padding: 18px 30px;

        &:hover {
          color: ${(props) => props.theme.color.white};
          background: ${(props) => props.theme.blue.dark};
          border-color: ${(props) => props.theme.blue.dark};
          box-shadow: 0 4px 12px 0 ${(props) => props.theme.blue.dark}12;
        }
      }
    }
  }

  .single-slide {
    .box {
      cursor: default;
    }
  }

  &.epharmacy {
    .slick-dots {
      li.slick-active {
        button {
          background: ${(props) => props.theme.green.dark};
        }
      }
    }
  }

  @media (max-width: 820px) {
    .box {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      .content {
        height: auto;
        background: ${(props) => props.theme.blue.dark}c9;
        margin: 0;
        padding: 10px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  @media (max-width: 480px) {
    .imageTimerStyle {
      bottom: -10px;
      left: 20px;
    }
    .box {
      & > div {
        > img {
          min-height: ${(props) => props?.isHeroPromoBanner ? "85px" : "160px"} !important;
        }
      }
    }
    .slick-slide {
      img {
        border: 1px solid ${(props) => props.theme.color.bannerBorder} !important;
      }
    }

    .box {
      .content {
        .line {
          font-size: 18px;
        }
        button {
          padding: 10px 15px;
          font-size: 14px;
        }
      }
    }
    .slick-slider {
      margin-bottom: ${(props) => props.dataLength === 1 ? '-20px': '0'};
      .slick-list {
        width: 100%;
        margin: 0;
      }
    }
  }
`;
